const logoContext = require.context('.', false, /\.png$/);

const logos = logoContext.keys().reduce((acc, path) => {
  const name = path.replace('./', '').replace('.png', '');
  const mod = logoContext(path);
  acc[name] = mod?.default ?? mod;
  return acc;
}, {});

export const getIntegrationLogo = (name) => logos[name?.toLowerCase?.() ?? name] ?? null;

export default logos;
